<template>
    <div>
        <v-select
            v-if="!buttons && !autocomplete && !iterator"
            :items="teacher ? [teacher] : teachers"
            :value="value"
            v-on:input="$emit('input', $event)"
            item-text="name"
            item-value="id"
            label="Teacher"
            :return-object="returnObject"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            outlined
            dense
            :loading="loading"
            :hideDetails="hideDetails"
            :clearable="clearable"
            :rules="rules"
            no-data-text=""
            @click:clear="$emit('clear')"
        ></v-select>
        <v-autocomplete
            v-if="autocomplete && !buttons && !iterator"
            ref="autoComplete"
            outlined
            return-object
            dense
            :loading="loading"
            :value="value"
            :items="teacher ? [teacher] : teachers"
            :hideDetails="hideDetails"
            :prepend-inner-icon="hideIcon ? null : 'people'"
            :menu-props="{
                closeOnContentClick: true,
            }"
            :clearable="clearable"
            :autofocus="autofocus"
            :rules="rules"
            :return-object="returnObject"
            item-value="id"
            item-text="name"
            label="Teacher"
            no-data-text=""
            class="soli-blue-text"
            @input="$emit('input', $event)"
            @keydown.enter.prevent
            @click:clear="$emit('clear')"
        />
        <v-list v-if="buttons && !autocomplete && !iterator">
            <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="list-item, list-item, list-item"
                v-if="loading"
            ></v-skeleton-loader
            ><v-list-item
                v-for="teacher in getTeachers"
                :key="teacher.id"
            >
                <SoliTeacher
                    :teacher="teacher"
                    @input="$emit('input', $event)"
                ></SoliTeacher></v-list-item
        ></v-list>

        <v-skeleton-loader
            v-if="iterator && loading"
            class="mx-auto my-3"
            type="list-item-avatar, list-item-avatar, list-item-avatar"
        ></v-skeleton-loader>
        <v-data-iterator
            v-if="iterator && !loading"
            :items="getTeachers"
            disable-pagination
            :search="search"
            hide-default-footer
            no-data-text=""
        >
            <template v-slot:header
                ><v-sheet style="position: sticky; top: 0px; z-index: 10"
                    ><SoliText
                        v-model="search"
                        class="pa-3"
                        icon="people"
                        :autofocus="autofocus"
                        label="Search Teachers"
                        hideDetails
                        fullRound /></v-sheet
            ></template>
            <template v-slot:item="data">
                <v-list class="soli-round px-3 py-0">
                    <SoliAvatarBtn
                        @click="$emit('input', returnObject ? data.item : data.item.id)"
                        class="w-full"
                        blueShadow
                        :avatar="data.item.photo_url ? `${data.item.photo_url}/m/80x80` : '/musicologie-m-white.png'"
                        :outlined="false"
                        :title="data.item.name" /></v-list></template
        ></v-data-iterator>
        <div
            class="pa-3"
            v-if="!teachers.length && !loading"
        >
            {{ error || 'Sorry, no teachers are available for this selection' }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        buttons: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        instrument: {},
        type: {},
        checkTime: {},
        checkTeacherConflicts: {},
        addMinutes: {},
        assignment: {},
        filterTeacher: {},
        filterLocation: {
            type: Number,
            default: null,
        },
        hideDetails: {},
        hideIcon: {},
        clearable: {},
        teacher: {},
        rules: {},
        all: {
            type: Boolean,
            default: false,
            description: 'Bypass availability checks',
        },
        inStudio: {
            type: Boolean,
            default: false,
        },
        returnObject: {
            type: Boolean,
            default: true,
        },
        autocomplete: {
            type: Boolean,
            default: false,
        },
        iterator: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            teachers: [],
            loading: false,
            search: null,
            error: null,
            tags: ['#KidFocused', '#CommunityManager', '#ocalHealth', '#Academia'],
        };
    },
    watch: {
        filterLocation(oldLocation, newLocation) {
            if (oldLocation !== newLocation) {
                this.getApiTeachers();
            }
        },
    },
    computed: {
        getTeachers() {
            return this.instrument
                ? this.teachers.filter(
                      (teacher) =>
                          teacher.instruments.map((i) => i.id).includes(this.instrument.id) &&
                          teacher.id !== this.filterTeacher
                  )
                : this.checkTime
                  ? this.checkConflicts()
                  : this.teachers;
        },
    },
    methods: {
        checkConflicts() {
            let start = new Date(this.checkTime[0] + ' ' + this.checkTime[1]);
            let end = this.addMinutes(start, this.checkTime[2].value);
            let lessons = this.checkTeacherConflicts(start, end);
            let lessonMap = lessons.map((l) => l.teacher.id);
            let availTeachers = this.teachers.filter(
                (teacher) => !lessonMap.includes(teacher.id) && teacher.id !== this.filterTeacher
            );
            return availTeachers;
        },
        getApiTeachers() {
            this.error = null;
            this.loading = true;
            axios
                .get('/api/users/teachers', {
                    params: {
                        filterLocation: this.filterLocation,
                        instrument_id: this.instrument ? this.instrument.id : null,
                        type: this.type,
                        all: Number(this.all),
                        inStudio: Number(this.inStudio),
                    },
                })
                .then((resp) => {
                    let response = resp.data.filter((e) => e.id !== this.filterTeacher);
                    this.teachers = this.teacher ? response.filter((e) => e.id == this.teacher.id) : response;
                    this.$emit('teachersLoaded');
                })
                .catch((error) => {
                    this.error =
                        error.response?.data?.errors?.filterLocation?.[0] ??
                        error.response?.data?.message ??
                        error.message;
                    this.$emit('error', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.getApiTeachers();
    },
};
</script>

<style></style>
